import { useState } from 'react'
import { dynamicGa4DataLayerPush } from '@which/shared'

import { GuidedPurchaseJourneyButton } from './Button/GuidedPurchaseJourneyButton'
import { analytics } from './Configs/analytics'
import {
  setLaunchLaptopHelperDismissed,
  useLaunchLaptopHelperDismissed,
} from './dismissLaunchLaptopHelperCookie'
import { useGuidedPurchaseItemSpec } from './hooks/useGuidedPurchaseItemSpec'
import { useShouldShowGuidedPurchaseJourney } from './hooks/useShouldShowGuidedPurchaseJourney'
import { GuidedPurchaseJourneyNavigation } from './Navigation/GuidedPurchaseJourneyNavigation'

export const GuidedPurchaseJourney = () => {
  const { shouldShowGuidedPurchaseJourney, journeyType } = useShouldShowGuidedPurchaseJourney()
  const itemSpec = useGuidedPurchaseItemSpec()
  const launchGuidedPurchaseJourneyDismissedFromCookie = useLaunchLaptopHelperDismissed()
  const [guidedPurchaseJourneyOpen, setGuidedPurchaseJourneyOpen] = useState(false)
  const [launchGuidedPurchaseJourneyDismissed, setLaunchGuidedPurchaseJourneyDismissedState] =
    useState(launchGuidedPurchaseJourneyDismissedFromCookie)

  const handleOpenGuidedPurchaseJourney = () => {
    setGuidedPurchaseJourneyOpen(true)
  }
  if (!shouldShowGuidedPurchaseJourney || launchGuidedPurchaseJourneyDismissed) {
    return null
  }

  const handleGuidedPurchaseJourneyClose = () => {
    dynamicGa4DataLayerPush({
      event: 'personalisation_tool_onward_journey',
      item_text: 'close',
      item_index: 1,
      action_group: 'onward_journey',
      item_parent_text: undefined,
      item_spec: itemSpec,
      item_url: undefined,
      item_group: 'personalisation tools',
      tool_name: analytics[journeyType].tool_name,
      item_personalisation: 'false',
    })

    setGuidedPurchaseJourneyOpen(false)
  }

  const handleLaunchGuidedPurchaseJourneyDismiss = () => {
    setLaunchLaptopHelperDismissed()
    setLaunchGuidedPurchaseJourneyDismissedState(true)
  }

  return guidedPurchaseJourneyOpen ? (
    <GuidedPurchaseJourneyNavigation
      handleClose={handleGuidedPurchaseJourneyClose}
      journeyType={journeyType}
    />
  ) : (
    <GuidedPurchaseJourneyButton
      categorySlug={journeyType}
      onClick={handleOpenGuidedPurchaseJourney}
      onDismiss={handleLaunchGuidedPurchaseJourneyDismiss}
    />
  )
}
